module.exports = __webpack_public_path__ + "img/co-investing2.db381834.svg";